import { useI18n } from 'vue-i18n'
import axios from 'axios'
import { notify } from '@kyvg/vue3-notification'

import { useAuthStore } from '@/stores/auth-store'
import { useConfirm } from '@/hooks/use-confirm'
import { MyButtonScheme } from '@/types/layout/my-button'
import { Report } from '@/types/driver-report'
import { emitter } from '@/utils/mitt'

export function useDeleteDriverReport() {
    const { t } = useI18n()
    const confirm = useConfirm()
    const authStore = useAuthStore()

    return async function (report: Report): Promise<boolean | undefined> {
        try {
            await confirm(
                t('deleteEntityTitle', { entity: t('driverReport') }),
                t('deleteEntityDescription', { entity: t('driverReport') }),
                {
                    confirmText: t('yes'),
                    cancelText: t('no'),
                    confirmButtonScheme: MyButtonScheme.Warning,
                },
            )
        } catch {
            return
        }

        await axios.delete(
            window.route('dr.company.reports.destroy', {
                company: authStore.companyId,
                report: report,
            }),
        )
        emitter.emit('fetchDriverReports')
        notify({ type: 'success', text: t('entityDeleted', { entity: t('driverReport') }) })
        return true
    }
}
